module.exports = __webpack_public_path__ + "static/media/portal coordinator.88c5031f.svg";